import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { IconArrowBackUp, IconX, IconReceipt2 } from '@tabler/icons-react';
import ConfirmationRefundPenjualan from '../../../components/Corfirmation/ConfirmationRefundPenjualan';

export default function RfPenjualan({
  modalPenjualan,
  closeModalPenjualan,
  detailBarangPenjualan,
  refundBarang,
  loadingRf,
}) {
  function numberWithCommas(x) {
    return x !== undefined && x !== null
      ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : '0';
  }

  const [openConfirmationRefundPenjualan, setOpenConfirmationRefundPenjualan] = useState(false);

  function closeModalConfirmationRefundPenjualan() {
    setOpenConfirmationRefundPenjualan(false);
  }

  function openModalConfirmationRefundPenjualan() {
    setOpenConfirmationRefundPenjualan(true);
  }

  return (
    <>
      <ConfirmationRefundPenjualan
        loadingRf={loadingRf}
        detailBarangPenjualan={detailBarangPenjualan}
        refundBarang={refundBarang}
        openConfirmationRefundPenjualan={openConfirmationRefundPenjualan}
        closeModalConfirmationRefundPenjualan={closeModalConfirmationRefundPenjualan}
      />

      <Transition appear show={modalPenjualan && !openConfirmationRefundPenjualan} as={Fragment}>
        <Dialog as="div" className="relative z-[80]" onClose={closeModalPenjualan}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/60 dark:bg-slate-950/80 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 sm:p-6 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white dark:bg-[#0f172a] p-5 sm:p-6 text-left align-middle shadow-2xl transition-all border border-slate-200 dark:border-slate-800">
                  {/* Header */}
                  <div className="flex items-start justify-between pb-4 border-b border-slate-100 dark:border-slate-800">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200/60 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm">
                        <IconReceipt2 size={22} stroke={2} />
                      </div>
                      <div>
                        <Dialog.Title as="h3" className="text-lg font-bold text-slate-900 dark:text-white leading-tight">
                          Detail Transaksi Penjualan
                        </Dialog.Title>
                        <div className="flex items-center gap-2 mt-1">
                          <span className="text-xs text-slate-500 dark:text-slate-400">Kode Faktur:</span>
                          <span className="font-mono font-bold text-xs bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-200 px-2 py-0.5 rounded border border-slate-200 dark:border-slate-700">
                            {detailBarangPenjualan?.kode_trx || '-'}
                          </span>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={closeModalPenjualan}
                      className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
                      title="Tutup"
                    >
                      <IconX size={20} />
                    </button>
                  </div>

                  {/* Body Details Card */}
                  <div className="mt-4 bg-slate-50/70 dark:bg-[#152037]/50 border border-slate-200/80 dark:border-slate-800/80 rounded-xl divide-y divide-slate-200/60 dark:divide-slate-800/60 overflow-hidden">
                    <div className="px-4 py-3 flex items-center justify-between text-sm">
                      <span className="text-slate-500 dark:text-slate-400 font-medium">Jenis Barang</span>
                      <span className="text-slate-900 dark:text-white font-bold">
                        {detailBarangPenjualan?.item?.jenis_kategori?.nama_jenis || '-'}
                      </span>
                    </div>
                    <div className="px-4 py-3 flex items-center justify-between text-sm">
                      <span className="text-slate-500 dark:text-slate-400 font-medium">Berat Item</span>
                      <span className="text-slate-800 dark:text-slate-200 font-semibold">
                        {detailBarangPenjualan?.item?.berat} gram
                      </span>
                    </div>
                    <div className="px-4 py-3 flex items-center justify-between text-sm">
                      <span className="text-slate-500 dark:text-slate-400 font-medium">Kadar Emas</span>
                      <span className="font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/30 border border-amber-200/60 dark:border-amber-800/40 px-2.5 py-0.5 rounded-md text-xs">
                        {detailBarangPenjualan?.item?.karat} Karat
                      </span>
                    </div>
                    <div className="px-4 py-3 flex items-center justify-between text-sm">
                      <span className="text-slate-500 dark:text-slate-400 font-medium">Harga Jual / gram</span>
                      <span className="text-slate-800 dark:text-slate-200 font-semibold">
                        Rp {numberWithCommas(detailBarangPenjualan?.harga_jual ?? 0)}
                      </span>
                    </div>
                    <div className="px-4 py-3 flex items-center justify-between text-sm bg-emerald-50/40 dark:bg-emerald-950/10">
                      <span className="text-slate-600 dark:text-slate-300 font-medium">Total Harga</span>
                      <span className="text-base font-extrabold text-emerald-600 dark:text-emerald-400">
                        Rp {numberWithCommas(detailBarangPenjualan?.total_harga ?? 0)}
                      </span>
                    </div>
                    <div className="px-4 py-3 flex items-center justify-between text-sm">
                      <span className="text-slate-500 dark:text-slate-400 font-medium">Dijual di Cabang</span>
                      <span className="text-slate-700 dark:text-slate-300 font-medium">
                        {detailBarangPenjualan?.user?.cabang?.nama_cabang || '-'}
                      </span>
                    </div>
                    <div className="px-4 py-3 flex items-center justify-between text-sm">
                      <span className="text-slate-500 dark:text-slate-400 font-medium">Tanggal Transaksi</span>
                      <span className="text-slate-600 dark:text-slate-400 text-xs font-mono">
                        {detailBarangPenjualan?.created_at || '-'}
                      </span>
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="mt-5 flex items-center justify-end gap-2.5 pt-1">
                    <button
                      type="button"
                      onClick={closeModalPenjualan}
                      className="px-4 py-2.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold text-sm rounded-xl transition cursor-pointer"
                    >
                      Tutup
                    </button>
                    <button
                      type="button"
                      onClick={openModalConfirmationRefundPenjualan}
                      className="px-5 py-2.5 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-400 hover:to-emerald-500 active:from-emerald-600 text-white font-bold text-sm rounded-xl shadow-md shadow-emerald-500/20 transition cursor-pointer flex items-center gap-2"
                    >
                      <IconArrowBackUp size={18} stroke={2.2} />
                      <span>Return</span>
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
